export default __webpack_public_path__ + "static/media/failure.e829a918.svg";